import { keyframes } from "@emotion/react";
import { WarningAmber } from "@mui/icons-material";
import { Box, CircularProgress } from "@mui/material";

// Keyframes for grow-shrink scale
const fadeSquare = keyframes`
  0%, 80%, 100% {
    transform: scale(0.75);
    opacity: 0.6;
  }
  40% {
    transform: scale(1.4);
    opacity: 1;
  }
`;

export const Loader = ({ text, error }) => {
    return (
        <div style={{
            // backgroundColor: "rgba(255,255,255,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "20vh"
            //zIndex: 9999
        }}>
            {error ? <WarningAmber color="error" fontSize={"large"} /> : <CircularProgress />}
            <p style={{ marginTop: "15px", color: "#333", fontWeight: "bold" }}>
                {error ? "Something went wrong. Please try uploading again." : text}
            </p>
        </div>
    );
}